import Vue from 'vue'
import VueRouter from 'vue-router'
import Registration from '../views/Registration.vue'

Vue.use(VueRouter)

	const routes = [
	{
		path: '/',
		name: 'Registration',
		component: Registration
	},
	{
		path: '/vacant-seat',
		name: 'RegistrationVacantSeat',
		component: () => import(/* webpackChunkName: "vacant-seat" */ '../views/RegistrationVacantSeat.vue')
	},
	{
		path: '/specialized-transport',
		name: 'RegistrationSpecializedTransport',
		component: () => import(/* webpackChunkName: "specialized-transport" */ '../views/RegistrationSpecializedTransport.vue')
	},
	{
		path: '/choice-of-school',
		name: 'RegistrationChoiceOfSchool',
		component: () => import(/* webpackChunkName: "choice-of-school" */ '../views/RegistrationChoiceOfSchool.vue')
	},
	{
		path: '/users',
		name: 'Users',
		component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
	},
	{
		path: '/user/:user_id',
		name: 'User',
		component: () => import(/* webpackChunkName: "user" */ '../views/User.vue')
	},
	{
		path: '/admin',
		name: 'Dashboard',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
	},
	{
		path: '/form/:registration_id',
		name: 'Form',
		component: () => import(/* webpackChunkName: "form" */ '../views/Form.vue')
	},
	{
		path: '/admin/vacant-seat',
		name: 'DashboardVacantSeat',
		component: () => import(/* webpackChunkName: "vacant-seat-admin" */ '../views/DashboardVacantSeat.vue')
	},
	{
		path: '/form/vacant-seat/:registration_vacant_seat_id',
		name: 'FormVacantSeat',
		component: () => import(/* webpackChunkName: "vacant-seat-form" */ '../views/FormVacantSeat.vue')
	},
	{
		path: '/admin/specialized-transport',
		name: 'DashboardSpecializedTransport',
		component: () => import(/* webpackChunkName: "specialized-transport-admin" */ '../views/DashboardSpecializedTransport.vue')
	},
	{
		path: '/form/specialized-transport/:registration_specialized_transport_id',
		name: 'FormSpecializedTransport',
		component: () => import(/* webpackChunkName: "specialized-transport-form" */ '../views/FormSpecializedTransport.vue')
	},
	{
		path: '/admin/choice-of-school',
		name: 'DashboardChoiceOfSchool',
		component: () => import(/* webpackChunkName: "choice-of-school-admin" */ '../views/DashboardChoiceOfSchool.vue')
	},
	{
		path: '/form/choice-of-school/:registration_choice_of_school_id',
		name: 'FormChoiceOfSchool',
		component: () => import(/* webpackChunkName: "choice-of-school-form" */ '../views/FormChoiceOfSchool.vue')
	},
	{
		path: '/account',
		name: 'Account',
		component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
	},
	{
		path: '/logout',
		name: 'Logout',
		component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue')
	},
	{
		path: '/config',
		name: 'Config',
		component: () => import(/* webpackChunkName: "configuration" */ '../views/Config.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
